<template>
	<div></div>
</template>

<script>
export default {
	mounted() {
		this.$router.replace({ path: '/', query: { salesChannel: 'Nembillet' } })
	},
}
</script>

<style lang="scss" scoped>
</style>